export { default as GlobalStyles } from "./globals/GlobalStyles";
export type { IThemeProps } from "./Theme";
export { themeRegistry } from "./Theme";
export { default as Icons } from "./utils/Icons";
export { default as Svg } from "./utils/Svg";
